


































































































import Vue from "vue";
import Auth from "@/lib/Auth";
import moment from "moment";

export default Vue.extend({
  name: "homeRelatorios",

  data() {
    return {
      ModuloInfo: [],
      loadingData: true,
      permissoes: {},
      lang: navigator.language,
      errors: [],
      moment: moment,
      isMobile: false,
    };
  },
  created() {
    this.permissoes = Auth.getUserPermissoes();
    this.isMobile = this.detectMobile();
  },

  methods: {
    detectMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
  },
});
